module.exports = __webpack_public_path__ + "img/logo.a44ccee1.png";